module.exports = __webpack_public_path__ + "static/img/case.39707dbe.png";